import React, { useState } from "react";
import { setBudgetAppTypeFilter } from "../../../../actions/actions/eventStats";
import { connect } from "react-redux";
import _ from "i18n";
import { generateFollowUp, updateFollowUp } from "../../../../actions/thunks/eventStats";
import { Icon } from "antd/lib/index";
import FilterModal from "../../../common/BudgetManagement/FilterModal";

const TypeFilter = ({
  auth,
  budgetManagement,
  followUp,
  originalFollowUp,
  budgetPerMonth,
  originalBudgetPerMonth,
  currentClient,
  setBudgetAppTypeFilter,
  generateFollowUp,
  updateFollowUp
}) => {

  const [visible, setVisible] = useState(false);
  const [nextAppType, setNextAppType] = useState('');

  const handleDontSaveClick = () => {
    setBudgetAppTypeFilter(nextAppType);
    setVisible(false);
  };

  const handleSaveClick = () => {
    const { followUp: bmFollowUp } = budgetManagement;

    if (bmFollowUp.length === 0) {
      const { appType, year, budgetPerMonth, globalBudget: { totalHTVA, registrantsCount, pricePerUnit } } = budgetManagement;
      generateFollowUp(appType, year, budgetPerMonth, totalHTVA, registrantsCount, pricePerUnit).then(() => {
        setBudgetAppTypeFilter(nextAppType);
        setVisible(false);
      });
    } else {
      const { annualTargetId, followUp: bmFollowUp } = budgetManagement;
      updateFollowUp(annualTargetId, bmFollowUp).then(() => {
        setBudgetAppTypeFilter(nextAppType);
        setVisible(false);
      });
    }
  };

  const handleCancelClick = () => {
    setVisible(false);
  };

  const handleTypeSelect = (appType) => {
    const followUpIsUnchanged = followUp.every((element, index) =>
      element.registrantsCount === originalFollowUp[index].registrantsCount &&
      element.followUpPricePerUnit === originalFollowUp[index].followUpPricePerUnit
    );
    const budgetPerMonthIsUnchanged = budgetPerMonth.every((element, index) =>
      element.registrantsCount === originalBudgetPerMonth[index].registrantsCount
    );

    if (followUpIsUnchanged && budgetPerMonthIsUnchanged) {
      setBudgetAppTypeFilter(appType);
    } else {
      setVisible(true);
      setNextAppType(appType);
    }
  };

  const checkIfAnAppTypeIsConfigured = () => {
    let isConfigured = false;
    const { appTypesAreConfigured } = budgetManagement;
    for (const prop in appTypesAreConfigured) {
      if (appTypesAreConfigured[prop] === true) {
        isConfigured = true;
      }
    }
    return isConfigured;
  };

  const allTabIsShowed = checkIfAnAppTypeIsConfigured();
  const currentClientId = currentClient.id;

  return (
    <div className={'create-BM-type-filter'}>
      <ul>
        {allTabIsShowed === true && (
          <li
            className={budgetManagement.appType === 'all' ? 'event-filter-app-type-all selected' : 'event-filter-app-type-all'}
            onClick={() => handleTypeSelect('all')}
          >
            <span>{_('ALL')}</span>
          </li>
        )}
        <li
          className={budgetManagement.appType === 'registering' ? 'event-filter-app-type-registering selected' : 'event-filter-app-type-registering'}
          onClick={() => handleTypeSelect('registering')}
        >
          <span>{_('TRAININGS')}</span>
          {budgetManagement.appTypesAreConfigured.registering === true && <Icon type="check" style={{ marginLeft: '5px' }} />}
        </li>
        {(auth.currentClient.businessType === 'SUPER_CHAIN' || auth.currentClient.businessType === 'MASTER_CHAIN') && (
          <li
            className={budgetManagement.appType === 'cycle' ? 'event-filter-app-type-cycle selected' : 'event-filter-app-type-cycle'}
            onClick={() => handleTypeSelect('cycle')}
          >
            <span>{_('CYCLES')}</span>
            {budgetManagement.appTypesAreConfigured.cycle === true && <Icon type="check" style={{ marginLeft: '5px' }} />}
          </li>
        )}
        {auth.currentClient.businessType === 'SUPER_CHAIN' && (
          <React.Fragment>
            <li
              className={budgetManagement.appType === 'cycle_essential' ? 'event-filter-app-type-cycle_essential selected' : 'event-filter-app-type-cycle_essential'}
              onClick={() => handleTypeSelect('cycle_essential')}
            >
              <span>{_('CYCLES Essentiel')}</span>
              {budgetManagement.appTypesAreConfigured.cycle_essential === true && <Icon type="check" style={{ marginLeft: '5px' }} />}
            </li>
            <li
              className={budgetManagement.appType === 'all_in' ? 'event-filter-app-type-seasons selected' : 'event-filter-app-type-seasons'}
              onClick={() => handleTypeSelect('all_in')}
            >
              <span>{_('SEASONS')}</span>
              {budgetManagement.appTypesAreConfigured.all_in === true && <Icon type="check" style={{ marginLeft: '5px' }} />}
            </li>
            <li
              className={budgetManagement.appType === 'premium' ? 'event-filter-app-type-premium selected' : 'event-filter-app-type-premium'}
              onClick={() => handleTypeSelect('premium')}
            >
              <span>PREMIUM</span>
              {budgetManagement.appTypesAreConfigured.premium === true && <Icon type="check" style={{ marginLeft: '5px' }} />}
            </li>

            <li
              className={budgetManagement.appType === 'monthly_premium' ? 'event-filter-app-type-premium selected' : 'event-filter-app-type-premium'}
              onClick={() => handleTypeSelect('monthly_premium')}
              style={{ marginLeft: "0.5rem" }}
            >
              <span>PREMIUM Mensuel</span>
              {budgetManagement.appTypesAreConfigured.monthly_premium === true && <Icon type="check" style={{ marginLeft: '5px' }} />}
            </li>
          </React.Fragment>
        )}

        {currentClientId === 9 && (
          <li
            className={budgetManagement.appType === 'congres' ? 'event-filter-app-type-congres selected' : 'event-filter-app-type-congres'}
            onClick={() => handleTypeSelect('congres')}
            style={{ marginLeft: "0.5rem" }}
          >
            <span>{_('CONGRESS')}</span>
            {budgetManagement.appTypesAreConfigured.congres === true && <Icon type="check" style={{ marginLeft: '5px' }} />}
          </li>
        )}
      </ul>
      <FilterModal
        visible={visible}
        budgetManagement={budgetManagement}
        handleDontSaveClick={handleDontSaveClick}
        handleSaveClick={handleSaveClick}
        handleCancelClick={handleCancelClick}
      />
    </div>
  );
};

const mapStateToProps = state => ({
  auth: state.auth,
  budgetManagement: state.budgetManagement,
  followUp: state.budgetManagement.followUp,
  originalFollowUp: state.budgetManagement.originalFollowUp,
  budgetPerMonth: state.budgetManagement.budgetPerMonth,
  originalBudgetPerMonth: state.budgetManagement.originalBudgetPerMonth,
  currentClient: state.auth.currentClient,
});

const mapDispatchToProps = {
  setBudgetAppTypeFilter,
  generateFollowUp,
  updateFollowUp
};

export default connect(mapStateToProps, mapDispatchToProps)(TypeFilter);


// WEBPACK FOOTER //
// ./app/components/Filters/EventStats/BudgetManagement/TypeFilter.js